import { motion } from "framer-motion"
import { forwardRef, useImperativeHandle, useState } from "react"
import "./emp-button.scss"

interface Props {
    text: string,
    onSubmit?: () => void,
}

const buttonTextVariants = {
    default: { opacity: 1 },
    loading: { opacity: 0 }
}

const spinnerVariants = {
    default: { opacity: 0 },
    loading: { opacity: 1 }
}
type EmpButtonVariantTypes = "default" | "loading"

export interface EmpButtonRef {
    setButtonState: (buttonState: EmpButtonVariantTypes) => void
}
const EmpButton = forwardRef((props: Props, ref) => {
    const { text, onSubmit } = props
    const [buttonVariant, setButtonVariant] = useState<EmpButtonVariantTypes>("default")

    useImperativeHandle(ref, () => {
        return {
            setButtonState
        }
    })

    const setButtonState = (buttonState: EmpButtonVariantTypes) => {
        setButtonVariant(buttonState)
    }

    return (
        <>
            <button
                className={`emp-button ${buttonVariant}`}
                onClick={() => { if (onSubmit) onSubmit() }}>
                <motion.div className="emp-loader"
                    variants={spinnerVariants}
                    initial="default"
                    animate={buttonVariant}
                    transition={{ duration: 0.1 }}
                >
                    <div
                        className="emp-spinner"
                    ></div>
                </motion.div>
                <motion.span
                    variants={buttonTextVariants}
                    initial="default"
                    animate={buttonVariant}
                    transition={{ duration: 0.1 }}
                >
                    {text}</motion.span>
            </button>

        </>
    )
})
export default EmpButton